import axios from 'axios';
// const CancelToken = axios.CancelToken;
// const source = CancelToken.source();


// axios.defaults.headers.common['Authorization'] = `Bearer ${window.atob(localStorage.getItem('accessToken'))}`;
// axios.defaults.headers.common['cancelToken'] = source.token;

export default axios;